import { useState } from 'react';
import { Users, Plus } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import type { Team } from '../../types';
import TeamCard from './TeamCard';
import TeamForm from './TeamForm';
import ConfirmDialog from '../common/ConfirmDialog';

export default function TeamList() {
  const { state, apiDeleteTeam } = useApp();
  const [showForm, setShowForm] = useState(false);
  const [editTeam, setEditTeam] = useState<Team | undefined>(undefined);
  const [deleteTeamId, setDeleteTeamId] = useState<string | null>(null);

  const handleEdit = (team: Team) => {
    setEditTeam(team);
    setShowForm(true);
  };

  const handleDelete = (teamId: string) => {
    setDeleteTeamId(teamId);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setEditTeam(undefined);
  };

  return (
    <div className="p-4 md:p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-brand-50 flex items-center justify-center">
            <Users size={20} className="text-brand-500" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-slate-800">Equipes</h2>
            <p className="text-sm text-slate-500">{state.teams.length} equipes na sua organização</p>
          </div>
        </div>
        <button
          onClick={() => setShowForm(true)}
          className="flex items-center gap-1.5 px-4 py-2 rounded-xl text-sm font-medium text-white bg-brand-500 hover:bg-brand-600 transition-colors"
        >
          <Plus size={16} />
          Nova Equipe
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {state.teams.map((team, index) => (
          <div
            key={team.id}
            className="animate-slide-in-up"
            style={{ animationDelay: `${index * 80}ms` }}
          >
            <TeamCard
              team={team}
              onEdit={() => handleEdit(team)}
              onDelete={() => handleDelete(team.id)}
            />
          </div>
        ))}
      </div>

      {showForm && <TeamForm team={editTeam} onClose={handleCloseForm} />}

      <ConfirmDialog
        isOpen={deleteTeamId !== null}
        title="Excluir equipe"
        message="Tem certeza que deseja excluir esta equipe? Esta ação não pode ser desfeita."
        confirmLabel="Excluir"
        onConfirm={() => {
          if (deleteTeamId) apiDeleteTeam(deleteTeamId);
          setDeleteTeamId(null);
        }}
        onCancel={() => setDeleteTeamId(null)}
      />
    </div>
  );
}
